// extracted by mini-css-extract-plugin
module.exports = {"page":"jx-z","cartModal":"kx-z","checkout":"lx-z","placeholder":"mx-z","account":"nx-z"};